import React from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { CheckCircle, XCircle, AlertCircle, MailX } from 'lucide-react';
import { Button } from './ui/button';

const STATUS_CONFIG = {
  success: {
    icon: CheckCircle,
    iconColor: 'text-emerald-600',
    bgColor: 'bg-emerald-50',
    borderColor: 'border-emerald-200',
    title: 'Subscription Confirmed!',
    message: "Your email has been verified. You'll now receive our latest blog posts and finance insights directly in your inbox.",
  },
  already: {
    icon: AlertCircle,
    iconColor: 'text-amber-600',
    bgColor: 'bg-amber-50',
    borderColor: 'border-amber-200',
    title: 'Already Verified',
    message: "Your email is already verified. You're all set to receive our blog updates!",
  },
  invalid: {
    icon: XCircle,
    iconColor: 'text-red-600',
    bgColor: 'bg-red-50',
    borderColor: 'border-red-200',
    title: 'Invalid Link',
    message: 'This confirmation link is invalid. Please try subscribing again.',
  },
  expired: {
    icon: AlertCircle,
    iconColor: 'text-amber-600',
    bgColor: 'bg-amber-50',
    borderColor: 'border-amber-200',
    title: 'Link Expired',
    message: 'This confirmation link has expired (valid for 24 hours). Please subscribe again to receive a new link.',
  },
  unsubscribed: {
    icon: MailX,
    iconColor: 'text-gray-600',
    bgColor: 'bg-gray-50',
    borderColor: 'border-gray-200',
    title: 'Unsubscribed',
    message: "You've been unsubscribed from our blog updates. We're sorry to see you go!",
  },
  unsubscribe_fail: {
    icon: XCircle,
    iconColor: 'text-red-600',
    bgColor: 'bg-red-50',
    borderColor: 'border-red-200',
    title: 'Unsubscribe Failed',
    message: 'We could not find this email address in our records.',
  },
};

export const SubscribeVerified = () => {
  const [searchParams] = useSearchParams();
  const statusKey = searchParams.get('status') || 'invalid';
  const config = STATUS_CONFIG[statusKey] || STATUS_CONFIG.invalid;
  const Icon = config.icon;

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <section className="pt-32 pb-20 px-4 sm:px-6">
        <div className="max-w-lg mx-auto text-center">
          <div data-testid="verify-status" className={`${config.bgColor} ${config.borderColor} border rounded-2xl p-8`}>
            <Icon className={`w-14 h-14 ${config.iconColor} mx-auto mb-4`} />
            <h1 className="text-2xl font-bold text-gray-900 mb-3">{config.title}</h1>
            <p className="text-gray-600 mb-6">{config.message}</p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <Link to="/blogs">
                <Button data-testid="go-to-blogs" className="bg-emerald-600 hover:bg-emerald-700 text-white px-6">
                  Read Our Blog
                </Button>
              </Link>
              <Link to="/">
                <Button data-testid="go-home" variant="outline" className="border-gray-300 px-6">
                  Go to Homepage
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};
